export const qk = {
  me: ['me'],
  models: ['models'],
  generations: ['generations'],
  generation: (id: string) => ['generation', id],
  elements: ['elements'],
  voices: ['voices'],
  projectPrompts: ['project-prompts'],
  images: ['images'],
  uploads: ['uploads'],
  storyboards: ['storyboards'],
  storyboard: (id: string) => ['storyboard', id],
  storyboardCapabilities: ['storyboard-capabilities'],
  mcpKey: ['mcp-key'],
} as const;
